module.exports = __webpack_public_path__ + "static/media/eshipper-portfolio_2x.eaacb2d8.jpeg";